<template>
  <BorrowerAttributeConstructor
    :questionText="questionText"
    :description="description"
    :descriptionTooltip="descriptionTooltip"
    :label="''"
    :tooltipText="tooltipText"
    :errorText="errorText"
    :helpText="helpText"
    :disclaimer="disclaimer"
  >
    <template v-slot:input>
      <div class="form-check">
        <input
          type="checkbox"
          :id="'ba' + question.id"
          class="form-check-input"
          :name="'ba' + question.id"
          :data-cy="question.alias"
          v-model="newValue"
          :value="newValue"
          :disabled="disabled"
          @change="onChange(v$.value, $event)"
        />
        <label class="form-check-label" :for="'ba' + question.id">
          <b v-if="newValue">{{ label }}</b>
          <span v-else>{{ label}}</span>
        </label>
      </div>
    </template>
  </BorrowerAttributeConstructor>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import get from 'lodash/get'
import BaseBorrowerAttributeMixin from './BaseBorrowerAttributeMixin'

export default {
  setup: (props) => {
    const initialValue = get(props, 'question.value', '0')
    const booleanValue = initialValue === '1' || initialValue === 1 || initialValue === true
    const newValue = ref(booleanValue)

    return {
      v$: useVuelidate(),
      newValue
    }
  },
  data() {
    return {
      errorMessage: 'Please select an answer',
    }
  },
  props: {
    disabled: Boolean,
    question: {}
  },
  emits: ['invalidity','answer'],
  created() {
    this.$watch('newValue', (value) => {
      this.$emit('invalidity', !value)
    }, {immediate: true})

    this.$watch('question.value', (value) => {
      const booleanValue = value === '1' || value === 1 || value === true
      if (this.newValue !== booleanValue) {
        this.newValue = booleanValue
      }
    })
  },
  computed: {
    errorText() {
      return get(this.v$, 'value.$error') ? this.errorMessage : ''
    }
  },
  methods: {
    onChange(v$, e) {
      v$.$touch()
      const answer = this.newValue ? 1 : 0
      this.$emit('answer', { value: answer, isInvalid: v$.$error })
    }
  },
  mixins: [BaseBorrowerAttributeMixin],
  validations: function () {
    return {
      value: {  }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@lendiodevs/lendio-styleguide/sass/elements/lendio-environment';

.borrowerAttributeBoolean {
  width: 350px;
}

.existing-loans {
  @include media-breakpoint-down(lg) {
    max-width: 325px;
  }
}
</style>
